import { Button } from '@chikara/ui';
import { LOGIN } from '@/shared/constants/routes';
import styles from './Onboarding.module.css';
import { t } from '@/i18n';

interface OnboardingErrorScreenProps {
    message?: string | null;
}

export function OnboardingErrorScreen({ message }: OnboardingErrorScreenProps) {
    return (
        <div className={styles.errorContainer}>
            <h2 className={styles.errorTitle}>{t('onboarding.error.title')}</h2>
            <p className={styles.errorMessage}>{message ?? t('onboarding.error.subtitle')}</p>
            <Button onClick={() => (window.location.href = LOGIN)} className={styles.submitButton}>
                {t('onboarding.error.action')}
            </Button>
        </div>
    );
}
